export default __webpack_public_path__ + "static/media/CourseThumbnail-CHW01.af6681d9.png";